/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StagingAction } from './StagingAction';
import {
    StagingActionFromJSON,
    StagingActionFromJSONTyped,
    StagingActionToJSON,
    StagingActionToJSONTyped,
} from './StagingAction';
import type { DiffEntry } from './DiffEntry';
import {
    DiffEntryFromJSON,
    DiffEntryFromJSONTyped,
    DiffEntryToJSON,
    DiffEntryToJSONTyped,
} from './DiffEntry';

/**
 * 
 * @export
 * @interface StagingRecordDto
 */
export interface StagingRecordDto {
    /**
     * 
     * @type {string}
     * @memberof StagingRecordDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof StagingRecordDto
     */
    rowIndex?: number;
    /**
     * 
     * @type {StagingAction}
     * @memberof StagingRecordDto
     */
    action?: StagingAction;
    /**
     * 
     * @type {string}
     * @memberof StagingRecordDto
     */
    entityType: string | null;
    /**
     * 
     * @type {string}
     * @memberof StagingRecordDto
     */
    matchedEntityId?: string | null;
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof StagingRecordDto
     */
    transformedData?: { [key: string]: any | null; } | null;
    /**
     * 
     * @type {{ [key: string]: DiffEntry; }}
     * @memberof StagingRecordDto
     */
    diff?: { [key: string]: DiffEntry; } | null;
    /**
     * 
     * @type {string}
     * @memberof StagingRecordDto
     */
    validationNotes?: string | null;
}



/**
 * Check if a given object implements the StagingRecordDto interface.
 */
export function instanceOfStagingRecordDto(value: object): value is StagingRecordDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    return true;
}

export function StagingRecordDtoFromJSON(json: any): StagingRecordDto {
    return StagingRecordDtoFromJSONTyped(json, false);
}

export function StagingRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StagingRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'rowIndex': json['rowIndex'] == null ? undefined : json['rowIndex'],
        'action': json['action'] == null ? undefined : StagingActionFromJSON(json['action']),
        'entityType': json['entityType'],
        'matchedEntityId': json['matchedEntityId'] == null ? undefined : json['matchedEntityId'],
        'transformedData': json['transformedData'] == null ? undefined : json['transformedData'],
        'diff': json['diff'] == null ? undefined : (mapValues(json['diff'], DiffEntryFromJSON)),
        'validationNotes': json['validationNotes'] == null ? undefined : json['validationNotes'],
    };
}

export function StagingRecordDtoToJSON(json: any): StagingRecordDto {
    return StagingRecordDtoToJSONTyped(json, false);
}

export function StagingRecordDtoToJSONTyped(value?: StagingRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'rowIndex': value['rowIndex'],
        'action': StagingActionToJSON(value['action']),
        'entityType': value['entityType'],
        'matchedEntityId': value['matchedEntityId'],
        'transformedData': value['transformedData'],
        'diff': value['diff'] == null ? undefined : (mapValues(value['diff'], DiffEntryToJSON)),
        'validationNotes': value['validationNotes'],
    };
}

